import { cnv_pixel, ym, rstat, rstat4 } from '../../utils/temp-empty-metrics';


import { NavLink } from 'react-router-dom';

import './Footer.css';
import logo from "../../assets/img/logo.svg";
import imgPDF from '../../assets/img/pdf-logo.svg';
import xtwitter from '../../assets/img/x-twitter.svg';


export const Footer = () => {
	function getCurrentYear() {
		return new Date().getFullYear()
	}
	return (
		<>
			<footer className="footer">
				<div className="footer__flex container">

					<div className="footer__logo logo">
						<NavLink to="/" className="logo__link">
							<img src={ logo } alt="Лого сайта mbcash" className="logo__img" width="265" height="45" />
						</NavLink><br />
						<img src={ imgPDF } alt="pdf" width="20" height="20" className='logo__pdf-img' />
						&nbsp;
						{/* <a
							href="/files/Onboarding_manual_EN.pdf"
							style="text-decoration: underline;color: #fa5e00;"
							target="_blank"
							onClick={() => {ym(95071208,'reachGoal','click-pdf-app');}}
						> </a>*/}
						<a href="/files/MB_Cash_Registration_EN.pdf"
							className="footer__orange-link"
							target="_blank"
							onClick={()=>{ym(95071208,'reachGoal','click-pdf-mbc')}}
						>Learn more about<br /> Mostbet Cash</a>
					</div>

					<div className="footer__share share">
						<figure className="share__block">
							<ul className="share__list">
								<li className="share__item">
									<a href="https://twitter.com/MBC_worldwide"
										target="_blank"
										rel="noreferrer"
										aria-label="social network x"
										onClick={()=>{
											ym(95071208,'reachGoal','click-twitter')
											rstat('event', 'share_twitter_icon_click', { 'cls': 'sample element click', 'href': 'https://twitter.com/MBC_worldwide'})
											rstat4('event', 'share_twitter_icon_click', { 'cls': 'sample element click', 'href': 'https://twitter.com/MBC_worldwide'})
										}}
									>
										<img src={ xtwitter } className='share__icon-xtwitter' alt="icon xtwitter" width="30" height="30" />
									</a>
								</li>

							</ul>
						</figure>
					</div>
					<div className="footer__copy">Copyright © 2009-{getCurrentYear()} «Mostbet». All rights reserved and protected by law. Mostbet uses cookies to enhance your website experience. By staying on the website, you agree to the use of these cookies.</div>

					<div className="footer__age-rate"><span className="icon-circle icon">18+</span></div>

				</div>
			</footer>
		</>
	)
}